/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React, { useEffect, useState } from 'react';
import Select from 'react-select';

import { Typography } from '@material-tailwind/react';


export interface SelectOption {
    value: string;
    label: string;
};

interface FormTagInputProps {
    id: string;
    value: string;
    setValue: (value: string) => void;
    label: string;
    isMulti?: boolean;
    labelClass?: string;
    labelColor?: string;
    wrapperClass?: string;
    placeholder: string;
    options: SelectOption[];
}

export const FormTagInput: React.FC<FormTagInputProps> = ({
    id,
    value,
    setValue,
    label,
    labelClass,
    labelColor,
    wrapperClass,
    options,
    placeholder,
    isMulti
}) => {
    const [opt_value, setOptValue] = useState<SelectOption | null>(null);

    useEffect(() => {
        setOptValue(options.find(option => option.value === value) || null);
    }, [value, options]);

    // Custom styles for react-select
    const customStyles = {
        control: (base: any) => ({
            ...base,
            borderRadius: '5px',
            borderWidth: '2px',
            borderColor: '#D9D9D9',
            color: 'black',
            '&:hover': {
                borderWidth: '2px',
                borderColor: '#cbd5e0',
            },
        }),
        option: (base: any) => ({
            ...base,
            color: 'black',
        }),
        multiValue: (base: any) => ({
            ...base,
            backgroundColor: '#1E293B',
            paddingLeft: '5px',
            color: 'white',
            borderRadius: '4px',
            borderWidth: '2px',
        }),
        multiValueLabel: (base: any) => ({
            ...base,
            color: 'white',
        }),
        multiValueRemove: (base: any) => ({
            ...base,
            color: 'white',
            ':hover': {
                backgroundColor: '#f87171',
                color: 'white',
            },
        }),
    };


    return (
        <div className={wrapperClass || "mb-6 space-y-1.5"}>
            <div className="flex justify-between">
                { label ?
                   <Typography
                        as="label"
                        htmlFor={id}
                        type="small"
                        color="default"
                        className={`${labelClass ? labelColor : 'font-semibold'} ${labelColor ? labelColor : 'text-black'}`}
                    >
                        {label}
                    </Typography>
                    : null
                }
            </div>
            <Select
                id={id}
                value={opt_value}
                onChange={(newValue) => {
                    //@ts-ignore
                    setOptValue(newValue);
                    //@ts-ignore
                    setValue(newValue?.value);
                }}
                options={options}
                isMulti={isMulti}
                className=''
                placeholder={placeholder}
                styles={customStyles}
            />
        </div>
    );
};

export default FormTagInput;
